import React from 'react';
import {chakra} from '@chakra-ui/react';

export const Logo = (props: any) => {
  const color = props.color || '#fff';

  return (
    <chakra.svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 2000 371"
      width="full"
      height="full"
      maxH={32}
      {...props}
      color={color}
    >
      <g strokeWidth="2" fill="none" strokeLinecap="butt">
        <path
          stroke="currentColor"
          strokeOpacity="0.753"
          vectorEffect="non-scaling-stroke"
          d="
            M 1598.17 7.29
            L 1598.12 8.96
          "
        />
        <path
          stroke="currentColor"
          strokeOpacity="0.753"
          vectorEffect="non-scaling-stroke"
          d="
            M 509.88 286.47
            L 509.93 285.80
          "
        />
        <path
          stroke="currentColor"
          strokeOpacity="0.753"
          vectorEffect="non-scaling-stroke"
          d="
            M 267.80 75.21
            L 153.07 208.66
            A 1.29 1.29 0.0 0 1 151.52 208.98
            L 49.86 159.73
            A 0.19 0.19 0.0 0 0 49.64 160.03
            L 69.99 181.03
          "
        />
        <path
          stroke="currentColor"
          strokeOpacity="0.753"
          vectorEffect="non-scaling-stroke"
          d="
            M 304.45 137.75
            L 304.41 262.32
            A 1.42 1.42 0.0 0 1 303.70 263.55
            L 153.02 350.55
            A 0.89 0.89 0.0 0 1 152.14 350.55
            L 20.21 274.85
          "
        />
      </g>

      <path
        fill="currentColor"
        d="
          M 1923.63 0.00
          Q 1933.17 0.55 1938.90 1.12
          C 1956.93 2.92 1975.03 7.89 1991.15 16.92
          A 0.75 0.74 -64.2 0 1 1991.47 17.85
          L 1975.00 57.83
          A 1.05 1.04 -64.3 0 1 1973.53 58.35
          C 1954.64 48.03 1933.32 42.24 1912.12 43.92
          C 1904.67 44.52 1899.22 45.57 1893.76 49.55
          C 1885.14 55.84 1885.31 68.17 1895.60 72.68
          Q 1901.35 75.20 1904.43 76.07
          Q 1916.44 79.43 1928.71 82.11
          Q 1944.36 85.54 1955.99 89.28
          Q 1962.89 91.50 1966.64 93.13
          Q 1979.02 98.50 1988.16 108.35
          C 1994.71 115.40 1998.34 123.88 1999.37 133.16
          Q 1999.67 135.83 2000.00 138.50
          L 2000.00 145.14
          C 1998.65 164.67 1988.57 180.69 1972.16 190.91
          Q 1955.67 201.18 1936.43 203.87
          Q 1922.41 205.83 1917.49 205.89
          Q 1910.90 205.99 1905.60 205.92
          C 1901.92 205.87 1899.43 205.31 1895.25 204.98
          Q 1878.81 203.65 1861.83 198.90
          Q 1849.32 195.40 1838.36 189.88
          Q 1833.22 187.29 1829.03 184.30
          A 0.50 0.49 30.1 0 1 1828.86 183.69
          L 1846.83 143.33
          A 0.51 0.50 -61.7 0 1 1847.56 143.11
          Q 1868.70 156.25 1893.25 160.57
          C 1896.01 161.06 1898.12 160.97 1900.78 161.65
          Q 1901.46 161.82 1903.78 161.97
          Q 1913.75 162.62 1923.64 161.78
          A 2.36 2.31 33.0 0 0 1924.28 161.65
          Q 1925.64 161.21 1928.99 160.75
          C 1936.89 159.67 1945.85 154.19 1944.72 144.81
          C 1943.49 134.52 1932.37 132.21 1924.29 129.58
          C 1920.74 128.42 1916.68 127.79 1913.02 126.68
          Q 1910.90 126.03 1908.50 125.51
          Q 1884.34 120.30 1869.52 114.95
          Q 1853.31 109.10 1842.39 96.38
          C 1834.95 87.72 1832.34 76.79 1832.13 65.12
          C 1831.52 31.01 1857.01 10.63 1887.54 3.28
          Q 1896.92 1.02 1912.68 0.00
          L 1923.63 0.00
          Z
        "
      />
      <path
        fill="currentColor"
        d="
          M 267.80 75.21
          L 153.07 208.66
          A 1.29 1.29 0.0 0 1 151.52 208.98
          L 49.86 159.73
          A 0.19 0.19 0.0 0 0 49.64 160.03
          L 69.99 181.03
          L 153.64 269.37
          A 0.60 0.60 0.0 0 0 154.52 269.35
          L 303.86 95.82
          A 0.30 0.30 0.0 0 1 304.39 96.02
          L 304.45 137.75
          L 304.41 262.32
          A 1.42 1.42 0.0 0 1 303.70 263.55
          L 153.02 350.55
          A 0.89 0.89 0.0 0 1 152.14 350.55
          L 20.21 274.85
          L 0.00 263.22
          L 0.00 87.78
          L 151.94 0.18
          A 0.66 0.66 0.0 0 1 152.60 0.18
          L 272.17 69.21
          A 0.50 0.50 0.0 0 1 272.30 69.97
          L 267.80 75.21
          Z
        "
      />
      <path
        fill="currentColor"
        d="
          M 631.31 201.95
          L 571.69 201.95
          A 0.33 0.33 0.0 0 1 571.38 201.72
          L 534.03 82.45
          A 0.33 0.33 0.0 0 0 533.40 82.44
          L 493.86 201.72
          A 0.33 0.33 0.0 0 1 493.55 201.95
          L 434.18 201.95
          A 0.33 0.33 0.0 0 1 433.87 201.72
          L 369.76 4.43
          A 0.33 0.33 0.0 0 1 370.07 4.00
          L 427.33 4.00
          A 0.33 0.33 0.0 0 1 427.64 4.23
          L 466.93 129.72
          A 0.33 0.33 0.0 0 0 467.56 129.73
          L 509.16 4.23
          A 0.33 0.33 0.0 0 1 509.47 4.00
          L 560.55 4.00
          A 0.33 0.33 0.0 0 1 560.86 4.23
          L 600.46 130.68
          A 0.33 0.33 0.0 0 0 601.09 130.69
          L 642.17 4.23
          A 0.33 0.33 0.0 0 1 642.48 4.00
          L 695.40 4.00
          A 0.33 0.33 0.0 0 1 695.71 4.43
          L 631.62 201.72
          A 0.33 0.33 0.0 0 1 631.31 201.95
          Z
        "
      />
      <rect
        fill="currentColor"
        x="715.96"
        y="4.01"
        width="56.10"
        height="197.94"
        rx="0.44"
      />
      <path
        fill="currentColor"
        d="
          M 966.96 47.15
          L 867.88 47.15
          A 0.45 0.45 0.0 0 0 867.43 47.60
          L 867.43 80.11
          A 0.45 0.45 0.0 0 0 867.88 80.56
          L 955.07 80.56
          A 0.45 0.45 0.0 0 1 955.52 81.01
          L 955.52 121.95
          A 0.45 0.45 0.0 0 1 955.07 122.40
          L 867.88 122.40
          A 0.45 0.45 0.0 0 0 867.43 122.85
          L 867.43 158.36
          A 0.45 0.45 0.0 0 0 867.88 158.81
          L 970.63 158.81
          A 0.45 0.45 0.0 0 1 971.08 159.26
          L 971.08 201.50
          A 0.45 0.45 0.0 0 1 970.63 201.95
          L 812.42 201.95
          A 0.45 0.45 0.0 0 1 811.97 201.50
          L 811.97 4.45
          A 0.45 0.45 0.0 0 1 812.42 4.00
          L 966.96 4.00
          A 0.45 0.45 0.0 0 1 967.41 4.45
          L 967.41 46.70
          A 0.45 0.45 0.0 0 1 966.96 47.15
          Z
        "
      />
      <path
        fill="currentColor"
        d="
          M 1076.75 120.01
          Q 1067.52 108.95 1057.87 97.21
          A 0.34 0.34 0.0 0 0 1057.27 97.43
          L 1057.27 201.21
          A 0.72 0.72 0.0 0 1 1056.55 201.93
          L 1002.75 201.93
          A 0.47 0.47 0.0 0 1 1002.28 201.46
          L 1002.28 4.50
          A 0.52 0.52 0.0 0 1 1002.80 3.98
          L 1047.92 3.98
          A 1.19 1.17 69.8 0 1 1048.82 4.41
          Q 1102.84 69.65 1116.43 85.92
          Q 1125.66 96.97 1135.30 108.71
          A 0.34 0.34 0.0 0 0 1135.91 108.49
          L 1135.91 4.71
          A 0.72 0.72 0.0 0 1 1136.63 3.99
          L 1190.43 3.99
          A 0.47 0.47 0.0 0 1 1190.90 4.46
          L 1190.90 201.42
          A 0.52 0.52 0.0 0 1 1190.38 201.94
          L 1145.26 201.94
          A 1.19 1.17 69.8 0 1 1144.35 201.51
          Q 1090.34 136.28 1076.75 120.01
          Z
        "
      />
      <path
        fill="currentColor"
        d="
          M 1375.95 4.00
          L 1430.55 4.00
          A 0.32 0.32 0.0 0 1 1430.85 4.45
          L 1346.13 201.76
          A 0.32 0.32 0.0 0 1 1345.84 201.95
          L 1291.12 201.95
          A 0.32 0.32 0.0 0 1 1290.83 201.76
          L 1206.39 4.45
          A 0.32 0.32 0.0 0 1 1206.69 4.00
          L 1266.59 4.00
          A 0.32 0.32 0.0 0 1 1266.88 4.20
          L 1320.21 131.94
          A 0.32 0.32 0.0 0 0 1320.80 131.95
          L 1375.66 4.19
          A 0.32 0.32 0.0 0 1 1375.95 4.00
          Z
        "
      />
      <path
        fill="currentColor"
        d="
          M 1598.17 7.29
          L 1598.12 8.96
          L 1598.05 46.63
          A 0.53 0.52 0.0 0 1 1597.52 47.15
          L 1498.84 47.15
          A 0.69 0.68 -0.0 0 0 1498.15 47.83
          L 1498.15 79.63
          A 0.94 0.93 0.0 0 0 1499.09 80.56
          L 1585.69 80.56
          A 0.57 0.56 -90.0 0 1 1586.25 81.13
          L 1586.25 121.76
          A 0.63 0.63 0.0 0 1 1585.62 122.39
          L 1498.78 122.39
          A 0.62 0.62 0.0 0 0 1498.16 123.01
          L 1498.16 158.13
          A 0.68 0.68 0.0 0 0 1498.84 158.81
          L 1601.22 158.81
          A 0.63 0.62 0.0 0 1 1601.85 159.43
          L 1601.85 201.37
          A 0.59 0.58 0.0 0 1 1601.26 201.95
          L 1443.17 201.95
          A 0.61 0.61 0.0 0 1 1442.56 201.34
          L 1442.56 4.62
          A 0.62 0.62 0.0 0 1 1443.18 4.00
          L 1597.63 4.00
          A 0.65 0.65 0.0 0 1 1598.28 4.68
          L 1598.17 7.29
          Z
        "
      />
      <path
        fill="currentColor"
        d="
          M 1815.29 201.38
          A 0.36 0.36 0.0 0 1 1815.00 201.95
          L 1756.23 201.95
          A 0.89 0.87 -16.8 0 1 1755.50 201.57
          L 1719.60 149.36
          A 0.60 0.58 71.6 0 0 1719.12 149.11
          L 1689.58 149.11
          A 0.45 0.45 0.0 0 0 1689.13 149.56
          L 1689.13 201.47
          A 0.48 0.48 0.0 0 1 1688.65 201.95
          L 1633.37 201.95
          A 0.34 0.33 90.0 0 1 1633.04 201.61
          L 1633.04 4.39
          A 0.37 0.37 0.0 0 1 1633.41 4.02
          Q 1696.80 3.97 1723.25 4.03
          C 1746.10 4.08 1769.49 8.65 1787.48 23.45
          C 1806.99 39.52 1814.11 63.32 1810.91 88.13
          C 1807.90 111.47 1794.18 128.87 1773.57 139.30
          A 0.70 0.69 -31.2 0 0 1773.31 140.32
          L 1815.29 201.38
          Z
          M 1689.08 48.53
          L 1689.18 105.63
          A 0.28 0.28 0.0 0 0 1689.46 105.91
          L 1725.76 105.84
          A 29.16 26.28 -0.1 0 0 1754.87 79.51
          L 1754.87 74.41
          A 29.16 26.28 -0.1 0 0 1725.66 48.18
          L 1689.36 48.25
          A 0.28 0.28 0.0 0 0 1689.08 48.53
          Z
        "
      />
      <path
        fill="currentColor"
        fillOpacity="0.502"
        d="
          M 1598.17 7.29
          L 1598.12 8.96
          L 1598.17 7.29
          Z
        "
      />
      <path
        fill="currentColor"
        fillOpacity="0.502"
        d="
          M 267.80 75.21
          L 292.01 89.00
          A 0.71 0.71 0.0 0 1 292.20 90.08
          L 172.94 228.66
          A 1.18 1.17 33.2 0 1 171.53 228.95
          Q 94.63 191.68 74.75 181.96
          Q 73.03 181.12 71.01 179.87
          Q 70.32 179.44 70.01 179.98
          Q 69.77 180.41 69.99 181.03
          L 49.64 160.03
          A 0.19 0.19 0.0 0 1 49.86 159.73
          L 151.52 208.98
          A 1.29 1.29 0.0 0 0 153.07 208.66
          L 267.80 75.21
          Z
        "
      />
      <path
        fill="currentColor"
        fillOpacity="0.502"
        d="
          M 20.21 274.85
          L 152.14 350.55
          A 0.89 0.89 0.0 0 0 153.02 350.55
          L 303.70 263.55
          A 1.42 1.42 0.0 0 0 304.41 262.32
          L 304.45 137.75
          L 323.88 115.58
          A 0.32 0.31 65.8 0 1 324.43 115.79
          L 324.43 282.87
          A 0.38 0.37 -15.8 0 1 324.25 283.19
          L 173.16 370.42
          A 1.98 1.98 0.0 0 1 171.18 370.42
          L 20.79 283.59
          A 1.40 1.40 0.0 0 1 20.09 282.36
          L 20.21 274.85
          Z
        "
      />
      <ellipse
        fill="currentColor"
        cx="1323.80"
        cy="263.85"
        rx="14.42"
        ry="12.49"
        transform="rotate(-11.0 1323.80 263.85)"
      />
      <ellipse
        fill="currentColor"
        cx="1775.41"
        cy="263.85"
        rx="14.42"
        ry="12.49"
        transform="rotate(-11.1 1775.41 263.85)"
      />
      <path
        fill="currentColor"
        d="
          M 1180.36 344.62
          A 0.25 0.25 0.0 0 0 1179.95 344.38
          Q 1167.73 354.53 1152.24 349.80
          C 1139.83 346.02 1133.04 333.71 1133.18 320.72
          Q 1133.37 303.28 1145.37 292.11
          C 1153.03 284.97 1162.60 281.80 1172.97 282.62
          Q 1182.97 283.41 1189.20 290.68
          A 0.39 0.39 0.0 0 0 1189.88 290.50
          L 1196.00 259.86
          A 0.76 0.75 5.6 0 1 1196.74 259.26
          L 1218.85 259.26
          A 0.55 0.54 5.6 0 1 1219.39 259.91
          L 1201.46 349.66
          A 0.65 0.65 0.0 0 1 1200.82 350.19
          L 1179.74 350.19
          A 0.40 0.40 0.0 0 1 1179.35 349.71
          L 1180.36 344.62
          Z
          M 1157.78 313.04
          Q 1155.70 319.62 1157.98 325.53
          Q 1160.45 331.93 1168.30 332.50
          C 1176.34 333.09 1181.96 328.22 1184.32 320.78
          Q 1186.39 314.19 1184.10 308.28
          Q 1181.63 301.88 1173.78 301.31
          C 1165.74 300.72 1160.12 305.59 1157.78 313.04
          Z
        "
      />
      <path
        fill="currentColor"
        d="
          M 1668.87 270.44
          L 1660.62 287.48
          A 0.56 0.55 -61.5 0 1 1659.84 287.72
          Q 1649.63 281.67 1638.16 281.59
          C 1632.84 281.56 1628.21 281.66 1624.06 284.73
          C 1620.59 287.31 1620.07 292.27 1624.38 294.44
          C 1630.78 297.66 1638.16 298.83 1645.40 301.17
          C 1657.38 305.03 1664.84 312.25 1662.52 326.25
          C 1659.65 343.59 1641.55 350.97 1625.96 351.86
          C 1613.25 352.59 1597.80 350.07 1586.43 343.27
          A 0.98 0.98 0.0 0 1 1586.07 341.97
          L 1595.01 325.09
          A 0.54 0.53 29.1 0 1 1595.76 324.88
          Q 1608.86 332.93 1624.26 333.04
          C 1630.21 333.09 1638.96 331.77 1638.51 324.63
          C 1638.20 319.59 1624.06 317.09 1619.90 315.75
          Q 1612.64 313.41 1611.37 312.90
          C 1604.87 310.30 1598.34 304.89 1597.30 297.57
          C 1594.84 280.26 1606.20 268.45 1622.28 264.51
          Q 1642.82 259.48 1662.77 266.80
          Q 1665.96 267.97 1668.67 269.74
          A 0.55 0.55 0.0 0 1 1668.87 270.44
          Z
        "
      />
      <path
        fill="currentColor"
        d="
          M 474.11 264.15
          L 497.60 264.15
          A 0.42 0.42 0.0 0 1 498.01 264.65
          L 480.99 349.84
          A 0.42 0.42 0.0 0 1 480.58 350.18
          L 457.09 350.18
          A 0.42 0.42 0.0 0 1 456.68 349.68
          L 473.70 264.49
          A 0.42 0.42 0.0 0 1 474.11 264.15
          Z
        "
      />
      <path
        fill="currentColor"
        d="
          M 1828.84 332.07
          L 1831.41 347.12
          A 0.73 0.72 74.1 0 1 1830.97 347.92
          Q 1817.62 353.41 1805.03 349.97
          C 1794.37 347.05 1790.26 336.95 1792.20 326.72
          Q 1795.39 309.90 1796.69 304.17
          A 0.51 0.51 0.0 0 0 1796.19 303.54
          L 1787.53 303.54
          A 0.44 0.43 5.9 0 1 1787.10 303.02
          L 1790.38 286.58
          A 0.57 0.57 0.0 0 1 1790.94 286.12
          L 1799.83 286.12
          A 0.48 0.47 -83.9 0 0 1800.29 285.74
          L 1803.53 269.50
          A 0.59 0.59 0.0 0 1 1804.11 269.03
          L 1826.41 269.03
          A 0.48 0.47 5.9 0 1 1826.88 269.60
          L 1823.67 285.70
          A 0.35 0.35 0.0 0 0 1824.01 286.12
          L 1838.22 286.12
          A 0.42 0.42 0.0 0 1 1838.63 286.63
          L 1835.37 302.95
          A 0.75 0.73 -84.2 0 1 1834.65 303.55
          L 1821.01 303.55
          A 1.21 1.21 0.0 0 0 1819.82 304.54
          Q 1817.44 317.32 1816.33 322.29
          Q 1815.06 327.98 1815.72 329.80
          C 1817.59 334.98 1824.03 333.45 1828.12 331.68
          A 0.52 0.52 0.0 0 1 1828.84 332.07
          Z
        "
      />
      <path
        fill="currentColor"
        d="
          M 509.88 286.47
          L 509.93 285.80
          L 510.32 284.24
          A 0.73 0.73 0.0 0 1 511.03 283.69
          L 531.96 283.69
          A 0.46 0.45 5.7 0 1 532.41 284.23
          L 531.33 289.67
          A 0.26 0.25 75.2 0 0 531.75 289.92
          Q 543.08 280.03 557.43 283.29
          Q 566.15 285.27 570.84 292.96
          A 0.37 0.37 0.0 0 0 571.42 293.02
          Q 581.83 282.35 595.91 282.50
          Q 604.30 282.59 610.11 286.57
          C 622.72 295.23 618.82 311.02 616.02 323.88
          Q 614.66 330.15 613.47 337.01
          Q 612.59 342.14 610.87 349.66
          A 0.68 0.68 0.0 0 1 610.21 350.19
          L 588.09 350.19
          A 0.52 0.52 0.0 0 1 587.59 349.55
          Q 589.16 342.53 589.75 339.04
          C 591.21 330.39 593.44 322.02 594.60 313.66
          C 595.43 307.73 593.63 302.43 586.78 302.33
          C 574.94 302.15 572.88 313.24 570.96 323.46
          Q 569.57 330.87 565.68 349.62
          A 0.71 0.69 5.5 0 1 564.99 350.18
          L 542.55 350.18
          A 0.32 0.31 7.1 0 1 542.24 349.79
          Q 542.79 347.67 549.43 315.00
          C 550.77 308.44 548.82 302.23 540.98 302.31
          C 532.78 302.40 528.75 309.11 527.24 316.45
          Q 522.84 337.92 520.71 349.54
          A 0.79 0.79 0.0 0 1 519.93 350.19
          L 497.87 350.19
          A 0.48 0.47 -84.4 0 1 497.41 349.62
          L 509.88 286.47
          Z
        "
      />
      <path
        fill="currentColor"
        d="
          M 660.24 289.88
          C 670.65 280.78 686.24 279.36 696.70 289.29
          C 697.79 290.32 698.40 291.94 699.25 292.95
          A 0.56 0.56 0.0 0 0 700.08 292.97
          Q 707.43 285.08 717.58 283.14
          Q 728.98 280.96 737.39 285.82
          C 750.03 293.12 747.92 307.58 745.17 320.73
          C 742.96 331.31 741.50 340.69 739.31 349.66
          A 0.70 0.69 -83.0 0 1 738.64 350.19
          L 716.64 350.19
          A 0.53 0.53 0.0 0 1 716.12 349.54
          C 717.59 342.85 718.36 337.30 719.76 331.16
          Q 721.81 322.15 723.08 313.57
          C 724.01 307.34 721.87 302.28 714.69 302.33
          C 705.62 302.39 702.29 309.67 700.55 318.17
          Q 698.22 329.54 694.20 349.65
          A 0.68 0.67 5.8 0 1 693.54 350.18
          L 671.18 350.18
          A 0.48 0.47 9.6 0 1 670.73 349.55
          Q 671.25 348.01 677.78 315.54
          C 678.98 309.56 677.96 302.79 670.68 302.33
          C 663.00 301.85 658.52 306.82 656.46 313.73
          C 654.45 320.47 653.69 327.52 651.99 334.99
          Q 650.39 342.05 649.22 349.63
          A 0.66 0.66 0.0 0 1 648.57 350.18
          L 626.05 350.18
          A 0.38 0.37 5.6 0 1 625.68 349.74
          L 638.75 284.35
          A 0.82 0.81 -84.4 0 1 639.55 283.69
          L 660.46 283.69
          A 0.47 0.47 0.0 0 1 660.92 284.25
          L 659.84 289.65
          A 0.24 0.24 0.0 0 0 660.24 289.88
          Z
        "
      />
      <path
        fill="currentColor"
        d="
          M 820.90 342.29
          A 0.48 0.48 0.0 0 1 820.78 342.95
          C 809.97 350.69 796.37 352.68 783.17 350.30
          C 769.03 347.75 758.50 338.46 757.44 323.66
          C 755.98 303.32 769.36 286.56 789.39 283.15
          C 815.36 278.73 835.71 294.59 829.14 322.31
          A 0.55 0.54 -83.2 0 1 828.61 322.73
          L 780.55 322.70
          A 0.32 0.32 0.0 0 0 780.23 323.06
          C 780.89 329.05 785.17 332.48 791.05 333.24
          Q 801.96 334.66 810.92 328.64
          A 0.50 0.50 0.0 0 1 811.61 328.77
          L 820.90 342.29
          Z
          M 782.34 310.44
          L 808.53 310.44
          A 0.36 0.36 0.0 0 0 808.89 310.08
          C 808.89 299.96 797.79 297.13 790.01 300.49
          Q 784.29 302.96 781.80 309.66
          A 0.58 0.58 0.0 0 0 782.34 310.44
          Z
        "
      />
      <path
        fill="currentColor"
        d="
          M 868.23 290.49
          C 873.41 284.72 883.50 282.38 890.87 282.51
          A 0.61 0.61 0.0 0 1 891.46 283.24
          L 887.52 302.93
          A 0.58 0.56 -82.4 0 1 886.93 303.39
          Q 880.40 303.03 878.54 303.34
          Q 866.05 305.47 863.32 318.13
          Q 863.29 318.28 856.97 349.64
          A 0.67 0.67 0.0 0 1 856.31 350.18
          L 833.91 350.18
          A 0.35 0.34 5.5 0 1 833.57 349.77
          L 846.65 284.31
          A 0.78 0.78 0.0 0 1 847.41 283.69
          L 868.35 283.69
          A 0.50 0.49 5.7 0 1 868.84 284.28
          L 867.65 290.20
          A 0.34 0.34 0.0 0 0 868.23 290.49
          Z
        "
      />
      <path
        fill="currentColor"
        d="
          M 973.29 344.68
          A 0.25 0.24 -14.9 0 0 972.89 344.45
          C 959.21 356.05 937.98 352.64 929.56 336.52
          C 923.70 325.31 925.17 310.69 931.81 299.85
          Q 937.73 290.17 948.16 285.47
          C 958.51 280.81 974.38 280.76 981.87 290.85
          A 0.44 0.43 32.5 0 0 982.65 290.68
          L 983.92 284.34
          A 0.82 0.81 5.6 0 1 984.72 283.69
          L 1006.92 283.69
          A 0.46 0.46 0.0 0 1 1007.37 284.23
          L 994.30 349.64
          A 0.68 0.68 0.0 0 1 993.63 350.19
          L 972.70 350.19
          A 0.42 0.42 0.0 0 1 972.29 349.69
          L 973.29 344.68
          Z
          M 950.54 312.94
          Q 948.40 319.51 950.64 325.45
          Q 953.06 331.87 960.92 332.51
          C 968.97 333.17 974.63 328.34 977.06 320.90
          Q 979.18 314.32 976.94 308.38
          Q 974.52 301.96 966.66 301.32
          C 958.62 300.66 952.95 305.49 950.54 312.94
          Z
        "
      />
      <path
        fill="currentColor"
        d="
          M 1043.99 283.68
          A 0.50 0.50 0.0 0 1 1044.48 284.28
          L 1043.38 289.79
          A 0.34 0.34 0.0 0 0 1043.97 290.09
          Q 1045.99 287.90 1049.23 286.25
          Q 1063.57 278.95 1077.41 285.52
          C 1086.82 289.99 1089.36 300.91 1087.75 310.78
          Q 1086.87 316.20 1080.12 349.62
          A 0.70 0.70 0.0 0 1 1079.43 350.19
          L 1057.41 350.19
          A 0.49 0.48 -86.3 0 1 1056.93 349.64
          Q 1057.48 345.46 1058.57 340.28
          Q 1061.36 326.97 1063.64 314.51
          C 1064.95 307.37 1062.69 302.44 1054.80 302.32
          C 1044.63 302.16 1040.57 310.18 1038.76 319.22
          Q 1033.40 345.91 1032.73 349.58
          A 0.73 0.73 0.0 0 1 1032.01 350.18
          L 1009.84 350.18
          A 0.54 0.53 5.7 0 1 1009.31 349.54
          L 1022.35 284.30
          A 0.77 0.76 -84.5 0 1 1023.10 283.68
          L 1043.99 283.68
          Z
        "
      />
      <path
        fill="currentColor"
        d="
          M 1282.21 342.28
          A 0.48 0.48 0.0 0 1 1282.09 342.94
          C 1271.28 350.68 1257.69 352.68 1244.48 350.31
          C 1230.34 347.77 1219.80 338.49 1218.73 323.69
          C 1217.26 303.35 1230.63 286.58 1250.66 283.16
          C 1276.62 278.72 1296.99 294.56 1290.44 322.29
          A 0.55 0.54 -83.3 0 1 1289.91 322.71
          L 1241.84 322.71
          A 0.32 0.32 0.0 0 0 1241.52 323.07
          C 1242.19 329.06 1246.47 332.49 1252.35 333.25
          Q 1263.26 334.66 1272.22 328.63
          A 0.50 0.50 0.0 0 1 1272.91 328.76
          L 1282.21 342.28
          Z
          M 1243.59 310.45
          L 1269.78 310.43
          A 0.36 0.36 0.0 0 0 1270.14 310.07
          C 1270.13 299.94 1259.03 297.12 1251.25 300.49
          Q 1245.53 302.97 1243.05 309.67
          A 0.58 0.58 0.0 0 0 1243.59 310.45
          Z
        "
      />
      <path
        fill="currentColor"
        d="
          M 1368.45 284.28
          L 1367.35 289.79
          A 0.34 0.34 0.0 0 0 1367.94 290.09
          Q 1369.96 287.90 1373.20 286.25
          Q 1387.54 278.95 1401.38 285.52
          C 1410.79 289.99 1413.33 300.91 1411.72 310.78
          Q 1410.84 316.20 1404.09 349.62
          A 0.70 0.70 0.0 0 1 1403.40 350.19
          L 1381.38 350.19
          A 0.49 0.48 -86.3 0 1 1380.90 349.64
          Q 1381.45 345.46 1382.54 340.28
          Q 1385.33 326.97 1387.61 314.51
          C 1388.92 307.37 1386.66 302.44 1378.77 302.32
          C 1368.60 302.16 1364.54 310.18 1362.73 319.22
          Q 1357.37 345.91 1356.70 349.58
          A 0.73 0.73 0.0 0 1 1355.98 350.18
          L 1333.81 350.18
          A 0.54 0.53 5.7 0 1 1333.28 349.54
          L 1346.32 284.30
          A 0.77 0.76 -84.5 0 1 1347.07 283.68
          L 1367.96 283.68
          A 0.50 0.50 0.0 0 1 1368.45 284.28
          Z
        "
      />
      <path
        fill="currentColor"
        d="
          M 1485.55 342.28
          A 0.48 0.48 0.0 0 1 1485.43 342.94
          C 1474.62 350.67 1461.03 352.67 1447.82 350.30
          C 1433.68 347.76 1423.14 338.48 1422.08 323.68
          C 1420.61 303.34 1433.98 286.57 1454.01 283.16
          C 1479.97 278.72 1500.33 294.56 1493.78 322.29
          A 0.55 0.54 -83.3 0 1 1493.25 322.71
          L 1445.18 322.70
          A 0.32 0.32 0.0 0 0 1444.86 323.06
          C 1445.53 329.05 1449.81 332.48 1455.69 333.24
          Q 1466.60 334.65 1475.56 328.63
          A 0.50 0.50 0.0 0 1 1476.25 328.76
          L 1485.55 342.28
          Z
          M 1446.97 310.44
          L 1473.18 310.45
          A 0.36 0.36 0.0 0 0 1473.54 310.09
          C 1473.54 299.96 1462.43 297.13 1454.65 300.49
          Q 1448.92 302.96 1446.43 309.66
          A 0.58 0.58 0.0 0 0 1446.97 310.44
          Z
        "
      />
      <path
        fill="currentColor"
        d="
          M 1532.88 290.48
          C 1538.06 284.71 1548.15 282.37 1555.52 282.50
          A 0.61 0.61 0.0 0 1 1556.11 283.23
          L 1552.17 302.92
          A 0.58 0.57 -82.4 0 1 1551.58 303.38
          Q 1545.05 303.02 1543.19 303.33
          Q 1530.70 305.47 1527.97 318.13
          Q 1527.94 318.28 1521.63 349.64
          A 0.67 0.67 0.0 0 1 1520.97 350.18
          L 1498.56 350.19
          A 0.35 0.34 5.5 0 1 1498.22 349.78
          L 1511.30 284.31
          A 0.78 0.78 0.0 0 1 1512.06 283.69
          L 1533.00 283.68
          A 0.50 0.49 5.7 0 1 1533.49 284.27
          L 1532.30 290.19
          A 0.34 0.34 0.0 0 0 1532.88 290.48
          Z
        "
      />
      <path
        fill="currentColor"
        d="
          M 1733.78 342.27
          A 0.48 0.48 0.0 0 1 1733.66 342.93
          C 1722.85 350.67 1709.26 352.67 1696.05 350.31
          C 1681.91 347.77 1671.37 338.49 1670.30 323.70
          C 1668.83 303.36 1682.19 286.59 1702.22 283.17
          C 1728.17 278.72 1748.54 294.56 1742.00 322.28
          A 0.55 0.54 -83.3 0 1 1741.47 322.70
          L 1693.41 322.71
          A 0.32 0.32 0.0 0 0 1693.09 323.07
          C 1693.76 329.06 1698.04 332.49 1703.92 333.25
          Q 1714.83 334.66 1723.78 328.63
          A 0.50 0.50 0.0 0 1 1724.47 328.76
          L 1733.78 342.27
          Z
          M 1695.21 310.45
          L 1721.40 310.43
          A 0.36 0.36 0.0 0 0 1721.76 310.07
          C 1721.75 299.95 1710.65 297.13 1702.87 300.50
          Q 1697.15 302.97 1694.67 309.67
          A 0.58 0.58 0.0 0 0 1695.21 310.45
          Z
        "
      />
      <path
        fill="currentColor"
        d="
          M 1903.59 342.27
          A 0.48 0.48 0.0 0 1 1903.47 342.93
          C 1892.66 350.68 1879.07 352.68 1865.86 350.31
          C 1851.72 347.78 1841.17 338.50 1840.10 323.70
          C 1838.62 303.36 1851.99 286.58 1872.02 283.16
          C 1897.98 278.71 1918.36 294.54 1911.82 322.28
          A 0.55 0.54 -83.3 0 1 1911.29 322.70
          L 1863.21 322.71
          A 0.32 0.32 0.0 0 0 1862.89 323.07
          C 1863.56 329.06 1867.85 332.49 1873.73 333.25
          Q 1884.64 334.66 1893.60 328.62
          A 0.50 0.50 0.0 0 1 1894.29 328.75
          L 1903.59 342.27
          Z
          M 1865.03 310.44
          L 1891.14 310.39
          A 0.36 0.36 0.0 0 0 1891.50 310.03
          C 1891.48 299.94 1880.41 297.14 1872.66 300.50
          Q 1866.96 302.98 1864.49 309.66
          A 0.58 0.58 0.0 0 0 1865.03 310.44
          Z
        "
      />
      <path
        fill="currentColor"
        d="
          M 1308.33 283.71
          L 1330.91 283.71
          A 0.32 0.32 0.0 0 1 1331.22 284.09
          L 1318.07 349.95
          A 0.32 0.32 0.0 0 1 1317.76 350.21
          L 1295.17 350.21
          A 0.32 0.32 0.0 0 1 1294.86 349.83
          L 1308.02 283.97
          A 0.32 0.32 0.0 0 1 1308.33 283.71
          Z
        "
      />
      <path
        fill="currentColor"
        d="
          M 1769.25 350.20
          L 1746.87 350.20
          A 0.42 0.42 0.0 0 1 1746.46 349.70
          L 1759.58 284.05
          A 0.42 0.42 0.0 0 1 1759.99 283.71
          L 1782.37 283.71
          A 0.42 0.42 0.0 0 1 1782.78 284.21
          L 1769.66 349.86
          A 0.42 0.42 0.0 0 1 1769.25 350.20
          Z
        "
      />
      <path
        fill="currentColor"
        fillOpacity="0.502"
        d="
          M 509.93 285.80
          L 509.88 286.47
          Q 509.82 286.10 509.93 285.80
          Z
        "
      />
    </chakra.svg>
  );
};

export default Logo;
